import styled from 'styled-components';
import { PrimaryButton } from 'ui/button';
import { PageHeader } from 'ui/pageHeader';
import { LinkButton } from 'ui/linkButton';
import { AddNew16 } from 'ui/icons/aurora/16px/AddNew16';
import { useModalContext } from 'utils/contexts/modal';

import { useLoginContext } from '../contexts/LoginContext';
import { useTranslations } from '../hooks/useTranslations';
import { MovableInkModalState } from '../types';
import { INTEGRATION_DOC, MovableInkModal } from '../constants';
import { colors } from 'ui/theme';

enum ButtonTarget {
  Add = 'add',
  Connect = 'connect',
}

export const testIds = {
  header: 'mi-header',
  primaryCTAbtnAdd: 'mi-header-cta-btn-add',
  primaryCTAbtnConnect: 'mi-header-cta-btn-connect',
};

const StyledLinkButton = styled(LinkButton)`
  text-decoration: none !important;
  color: ${colors.white} !important;
`;

export const IntegrationsHeader = () => {
  const { authCode, authStateIsValid, authUrl } = useLoginContext();
  const { showModal } = useModalContext<MovableInkModalState>();
  const { t } = useTranslations();
  const buttonTarget = authCode && authStateIsValid ? ButtonTarget.Add : ButtonTarget.Connect;

  const onAddAccount = () => {
    // prompt user to create integration
    showModal({
      modalId: MovableInkModal.Add,
      code: authCode,
    });
  };

  return (
    <PageHeader
      data-test={testIds.header}
      documentation={{
        href: INTEGRATION_DOC,
        content: t('link.documentation'),
      }}
      pageActions={
        buttonTarget === ButtonTarget.Add ? (
          <PrimaryButton onClick={onAddAccount} data-test={testIds.primaryCTAbtnAdd}>
            <AddNew16 />
            <span>{t('button.add')}</span>
          </PrimaryButton>
        ) : (
          <StyledLinkButton to={authUrl} isAngular data-test={testIds.primaryCTAbtnConnect}>
            <AddNew16 />
            <span>{t('button.add')}</span>
          </StyledLinkButton>
        )
      }
    >
      {t('header.movableInk')}
    </PageHeader>
  );
};
